import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  userName: z.string(),
  name: z.string(),
});

export const getUsersSchema = z.array(
  z.object({
    id: z.string(),
    userName: z.string(),
    name: z.string(),
    mwUserTypeID: z.string(),
    roleList: z.array(z.string()),
    companySiteList: z.array(z.string()),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
  })
);

export type GetUsersResponse = z.infer<typeof getUsersSchema>;
